import { createAction } from "@ngrx/store";

export const init = createAction("[Room Mixer] Init");
export const destroy = createAction("[Room Mixer] Destroy");

export const roomMixerDelete = createAction("[Room Mixer] Room Mixer Delete");

export const roomMixerStatesShift = createAction(
  "[Room Mixer] Room Mixer States Shift"
);
